module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-asset-management"
  }, [_c('div', {
    staticClass: "component-backoffice-category-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.parkingGroups), function(parkingGroup, index) {
    return _c('div', {
      staticClass: "column small-12 large-4 category",
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('div', {
      staticClass: "inner-content card"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column shrink"
    }, [(_vm.activeIndex === index) ? _c('dropdown', {
      attrs: {
        "icon": 'fa fa-ellipsis-v fa-2x action',
        "position": 'top'
      }
    }, [_c('ParkingGroupButtons', {
      attrs: {
        "item": parkingGroup
      }
    })], 1) : _vm._e()], 1), _c('div', {
      staticClass: "column",
      on: {
        "click": function($event) {
          return _vm.setSearch(index, parkingGroup)
        }
      }
    }, [_c('h3', [_c('small', [_vm._v("PG" + _vm._s(parkingGroup.id) + " ")]), _c('span', [_vm._v(_vm._s(parkingGroup.name))])]), _c('small', [_vm._v("BM: " + _vm._s(parkingGroup.reservation_type))])])])])])
  }), 0), _vm._l((_vm.parkingGroups), function(parkingGroup, index) {
    return (_vm.activeIndex === index) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column text left"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'add-parking-lot',
          params: {
            id: parkingGroup.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "button small"
    }, [_vm._v("Add new Parking Lot")])])], 1)]) : _vm._e()
  }), _c('div', {
    staticClass: "row column"
  }, [(_vm.parking_group !== null) ? _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  }) : _vm._e()], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fcf8e354!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/AssetManagement.vue
// module id = 2683
// module chunks = 1